module.exports = __webpack_public_path__ + "static/media/list_edit.40f05711.png";